import { AskusStoreInterface, IAskus, IAskusAnswer, IAskusQuestion } from '@/models/askus.model';
import { PersistentStore } from './main';
import { IPagerResponse } from '@/models/pager.model';
import askusRepository from '@/api/askusRepository';

class AskusStore extends PersistentStore<AskusStoreInterface> {
  protected data(): AskusStoreInterface {
    return {
      pager: {
        current_page: 1,
        entries_per_page: 0,
        total_entries: 0,
      },
      question: [],
      isLoadingContent: false,
      askus: {
        description: '',
        id: 0,
        name: '',
        default_sort: '',
        default_sort_dir: '',
        has_recommendations: 0,
        overview: '',
        defaultSort: '',
        anon_questions: 0,
        new_questions: 0,
        attributes: [],
      },
      answers: [],
      suggestions: [],
      filter: {
        sort: '',
        text: '',
      },
      loadingAskus: true,
    };
  }

  setIsLoadingContent(value: boolean) {
    this.state.isLoadingContent = value;
  }
  setPager(pager: IPagerResponse) {
    this.state.pager = pager;
  }
  setQuestions(questions: IAskusQuestion[]) {
    this.state.question = questions;
  }
  setAskusId(askusid: number) {
    this.fetchAskus(askusid);
  }
  setDefaultFilter(sort: string, orientation: string) {
    const filterTypes = new Map().set('desc', '-').set('asce', '%2B');
    orientation = filterTypes.get(orientation);
    this.state.askus.defaultSort = orientation.concat(sort);
    this.state.filter.sort = orientation.concat(sort);
  }
  setFilter(sort: string, text: string) {
    this.state.filter.sort = sort;
    this.state.filter.text = text;
  }
  setAskus(askus: IAskus) {
    this.state.askus = askus;
    this.setDefaultFilter(askus.default_sort, askus.default_sort_dir);
  }
  setAnswers(answers: IAskusAnswer[]) {
    this.state.answers = answers;
  }
  setSuggestions(suggestions: IAskusQuestion[]) {
    this.state.suggestions = suggestions;
  }
  resetSuggestions() {
    this.state.suggestions = [];
  }
  resetAnswers() {
    this.state.answers = [];
  }
  resetQuestion() {
    askusRepository
      .getQuestions(this.state.askus.id, 1, this.state.askus.defaultSort, { text: '' })
      .then((res: any) => {
        this.setQuestions(res.data.data);
        this.setPager(res.data.pager);
      });
    this.state.filter.sort = this.state.askus.defaultSort;
    this.state.filter.text = '';
  }
  fetchAnswer(questionid: number) {
    askusRepository.getAnswer(questionid).then((res: any) => {
      this.setAnswers(res.data.data);
    });
  }
  fetchQuestions() {
    this.state.isLoadingContent = true;
    const page = this.state.pager.current_page;
    askusRepository
      .getQuestions(this.state.askus.id, page, this.state.filter.sort, { text: this.state.filter.text })
      .then((res: any) => {
        this.setQuestions(res.data.data);
        this.setPager(res.data.pager);
      })
      .finally(() => {
        this.state.isLoadingContent = false;
      });
  }
  updateToPage(page: number) {
    this.state.pager.current_page = page;
  }
  fetchAskus(askusid: number) {
    this.state.loadingAskus = true;
    askusRepository
      .getAskus(askusid)
      .then((res: any) => {
        this.setAskus(res.data.data);
        if (!this.state.isLoadingContent) {
          this.fetchQuestions();
        }
      })
      .finally(() => {
        this.state.loadingAskus = false;
      });
  }
  getSuggestions(askusid: number, text: string) {
    askusRepository.getSuggestions(askusid, text).then((res: any) => {
      this.setSuggestions(res.data.data);
    });
  }
}

export const askusStore: AskusStore = new AskusStore('ASKUS_STORE');
